import { useState, useEffect } from 'react'

const CONSENT_KEY = 'margins_cookie_consent'

export default function CookieBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY)
    if (!consent) setTimeout(() => setVisible(true), 1500)
  }, [])

  function accept() {
    localStorage.setItem(CONSENT_KEY, 'accepted')
    setVisible(false)
    // Enable GA now that user has consented
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
        ad_storage: 'denied',
      })
    }
  }

  function decline() {
    localStorage.setItem(CONSENT_KEY, 'declined')
    setVisible(false)
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
      })
    }
  }

  if (!visible) return null

  return (
    <div style={s.banner} role="dialog" aria-label="Cookie consent">
      <div style={s.inner}>
        <div style={s.text}>
          <p style={s.title}>We use cookies</p>
          <p style={s.body}>
            We use Google Analytics to understand how people use The Margins — no ads, no tracking for commercial purposes.
            You can decline and the site works exactly the same.{' '}
            <a href="/privacy" style={s.link}>Privacy policy →</a>
          </p>
        </div>
        <div style={s.actions}>
          <button style={s.decline} onClick={decline}>Decline</button>
          <button style={s.accept} onClick={accept}>Accept</button>
        </div>
      </div>
    </div>
  )
}

const s = {
  banner: {
    position: 'fixed', bottom: '1.5rem', left: '50%',
    transform: 'translateX(-50%)',
    width: 'min(560px, calc(100vw - 2rem))',
    background: 'var(--paper)',
    border: '1px solid var(--rule)',
    borderRadius: 12,
    boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
    zIndex: 9990,
    overflow: 'hidden',
  },
  inner: {
    display: 'flex', alignItems: 'center', gap: '1.5rem',
    padding: '1.25rem 1.5rem', flexWrap: 'wrap',
  },
  text: { flex: 1, minWidth: 200 },
  title: {
    fontFamily: "'DM Mono', monospace",
    fontSize: '0.65rem', letterSpacing: '0.12em',
    textTransform: 'uppercase', color: 'var(--ink)',
    marginBottom: '0.3rem',
  },
  body: {
    fontFamily: "'Space Grotesk', sans-serif",
    fontSize: '0.8rem', color: 'var(--muted)', lineHeight: 1.6,
  },
  link: { color: 'var(--accent)', textDecoration: 'underline' },
  actions: { display: 'flex', gap: '0.5rem', flexShrink: 0 },
  decline: {
    background: 'none', border: '1px solid var(--rule)',
    color: 'var(--muted)', padding: '0.5rem 1rem',
    fontFamily: "'DM Mono', monospace", fontSize: '0.65rem',
    letterSpacing: '0.08em', cursor: 'pointer', borderRadius: 6,
  },
  accept: {
    background: 'var(--ink)', border: 'none',
    color: 'var(--paper)', padding: '0.5rem 1rem',
    fontFamily: "'DM Mono', monospace", fontSize: '0.65rem',
    letterSpacing: '0.08em', cursor: 'pointer', borderRadius: 6,
  },
}
